<template>
  <div>
    <div class="page page__list">
      <search-bar
        @search="onSearch"
        name="is_station"
        placeholder="输入工位进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.is_id"
          :to="'/quality/ipqcset/' + item.is_id"
        >
          <div class="weui-cell__bd">
            <p>{{ item.is_code }}</p>
            <p class="list-item-muted">抽样数 {{ item.is_qty }}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{ item.is_station }}</p>
            <span
              class="list-item-status"
              :class="{ warning: item.is_status != '已审核' }"
              >{{ item.is_status }}</span
            >
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{ items.length }}笔</label>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/storage/ipqcset/list",
      filters: [
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
            }
          ],
        },
      ],
    };
  }
};
</script>